// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"474":"4090afd0","989":"b430ce5f"}[chunkId] + ".chunk.css";
};